import { fetchValuation } from '../api/vietcap'

export default {
  props: {
    symbol: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      pe: [],
      pb: [],
      loading: false,
      empty: false,
    }
  },

  watch: {
    symbol() {
      this.fetchData()
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      const { symbol } = this
      if (symbol === '') {
        return
      }

      this.empty = false
      this.loading = true
      fetchValuation(symbol)
        .then(({ pe, pb }) => {
          if (symbol !== this.symbol) return
          this.pe = pe
          this.pb = pb
          this.empty = pe.length === 0 && pb.length === 0
        })
        .catch(() => {
          if (symbol !== this.symbol) return
          this.pe = []
          this.pb = []
          this.empty = true
        })
        .finally(() => {
          if (symbol === this.symbol) this.loading = false
        })
    },
  },

  render() {
    return this.$scopedSlots.default({
      pe: this.pe,
      pb: this.pb,
      loading: this.loading,
      empty: this.empty,
    })
  },
}
